function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 29.6667C14.5272 29.6667 13.3333 28.4728 13.3333 27.0001V3.00008C13.3333 1.52732 14.5272 0.333414 16 0.333414C17.4728 0.333414 18.6667 1.52732 18.6667 3.00008V27.0001C18.6667 28.4728 17.4728 29.6667 16 29.6667ZM30.4377 22.219C29.3963 23.2604 27.7079 23.2604 26.6665 22.219L22.6665 18.219C20.8887 16.4413 20.8887 13.5589 22.6665 11.7811L26.6665 7.78113C27.7079 6.73973 29.3963 6.73973 30.4377 7.78113C31.4791 8.82253 31.4791 10.511 30.4377 11.5524L26.99 15.0001L30.4377 18.4478C31.4791 19.4892 31.4791 21.1776 30.4377 22.219ZM1.5621 22.219C0.520695 21.1776 0.520695 19.4892 1.5621 18.4478L5.00981 15.0001L1.5621 11.5524C0.520699 10.511 0.5207 8.82253 1.5621 7.78113C2.6035 6.73973 4.29193 6.73973 5.33333 7.78113L9.33333 11.7811C11.1111 13.5589 11.1111 16.4413 9.33333 18.219L5.33333 22.219C4.29193 23.2604 2.60349 23.2604 1.5621 22.219Z",
  fill: "black",
  fillOpacity: 0.3
});

function SvgTransformGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformGray);
export default __webpack_public_path__ + "static/media/transform-gray.949fbe9b.svg";
export { ForwardRef as ReactComponent };